import React from "react";
import type { RouteObject } from "react-router-dom";

const ActivityPage = React.lazy(() => import("./ActivityPage"));

// PENDING: PENDING-NAV-ROUTES. Sample page: no backend.
export const buildActivityRoutes = (): RouteObject[] => [{ path: "/activity", element: <ActivityPage /> }];
